(function () {
  'use strict';

  console.log('LUXIAUR GIFT JS LOADED');

  const GIFT_VARIANTS = {
    black: 42477458653261,
    white: 43182744338509
  };

  const GIFT_PROPERTY = '_luxiaur_complimentary_gift';

  let popupOpen = false;
  let giftProcessing = false;
  let lastCartSignature = '';

  /*
   * --------------------------------------------------
   * ELIGIBILITY
   * --------------------------------------------------
   */

  function isEligiblePage() {
    return !!document.querySelector(
      '[data-luxiaur-gift-eligible="true"]'
    );
  }


  /*
   * --------------------------------------------------
   * CART
   * --------------------------------------------------
   */

  async function getCart() {
    const response = await fetch(
      `${Shopify.routes.root}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Could not retrieve cart');
    }

    return response.json();
  }


  function hasGift(cart) {
    return cart.items.some(function (item) {
      return (
        item.properties &&
        item.properties[GIFT_PROPERTY] === 'true'
      );
    });
  }


  function getCartSignature(cart) {
    return cart.items
      .map(function (item) {
        return `${item.key}:${item.quantity}`;
      })
      .join('|');
  }


  /*
   * --------------------------------------------------
   * POPUP CREATION
   * --------------------------------------------------
   */

  function createPopup() {

    if (
      document.getElementById(
        'luxiaur-gift-popup'
      )
    ) {
      return;
    }

    const popup =
      document.createElement('div');

    popup.id =
      'luxiaur-gift-popup';

    popup.innerHTML = `
      <div class="luxiaur-gift-overlay">

        <div class="luxiaur-gift-modal">

          <button
            type="button"
            class="luxiaur-gift-close"
            aria-label="Close"
          >
            ×
          </button>

          <div class="luxiaur-gift-icon">

            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >

              <rect
                x="3"
                y="9"
                width="18"
                height="12"
                rx="1"
              />

              <path d="M12 9v12M3 13h18"/>

              <path
                d="M12 9H7.5a2.5 2.5 0 1 1 2.5-2.5V9Z"
              />

              <path
                d="M12 9h4.5A2.5 2.5 0 1 0 14 6.5V9Z"
              />

            </svg>

          </div>

          <h2>
            Your complimentary gift
          </h2>

          <p class="luxiaur-gift-subtitle">
            Choose your Silk Travel Case color.
          </p>

          <div class="luxiaur-gift-options">

            <button
              type="button"
              class="luxiaur-gift-option"
              data-gift-color="black"
            >

              <span
                class="luxiaur-gift-swatch luxiaur-swatch-black"
              ></span>

              <span>
                Black
              </span>

            </button>


            <button
              type="button"
              class="luxiaur-gift-option"
              data-gift-color="white"
            >

              <span
                class="luxiaur-gift-swatch luxiaur-swatch-white"
              ></span>

              <span>
                White
              </span>

            </button>

          </div>

          <p class="luxiaur-gift-note">
           Complimentary for a limited time.
          </p>

        </div>

      </div>
    `;

    document.body.appendChild(popup);


    /*
     * CLOSE BUTTON
     */

    popup.querySelector(
      '.luxiaur-gift-close'
    ).addEventListener(
      'click',
      closePopup
    );


    /*
     * CLICK OUTSIDE MODAL
     */

    popup.querySelector(
      '.luxiaur-gift-overlay'
    ).addEventListener(
      'click',
      function (event) {

        if (
          event.target ===
          event.currentTarget
        ) {
          closePopup();
        }

      }
    );


    /*
     * COLOR BUTTONS
     */

    popup.querySelectorAll(
      '[data-gift-color]'
    ).forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            const color =
              button.getAttribute(
                'data-gift-color'
              );

            /*
             * Close popup FIRST
             */
            closePopup();

            /*
             * Then add selected gift
             */
            addGift(color);

          }
        );

      }
    );

  }


  /*
   * --------------------------------------------------
   * OPEN POPUP
   * --------------------------------------------------
   */

  function openPopup() {

    if (popupOpen) {
      return;
    }

    createPopup();

    const popup =
      document.getElementById(
        'luxiaur-gift-popup'
      );

    const overlay =
      popup.querySelector(
        '.luxiaur-gift-overlay'
      );


    /*
     * Make sure overlay can receive
     * clicks when popup is open.
     */

    overlay.style.pointerEvents =
      'auto';


    popup.classList.add(
      'is-visible'
    );


    document.documentElement.classList.add(
      'luxiaur-gift-popup-open'
    );


    document.body.classList.add(
      'luxiaur-gift-popup-open'
    );


    popupOpen = true;


    console.log(
      'LUXIAUR: Gift color popup opened'
    );

  }


  /*
   * --------------------------------------------------
   * CLOSE POPUP
   * --------------------------------------------------
   */

  function closePopup() {

    const popup =
      document.getElementById(
        'luxiaur-gift-popup'
      );

    if (!popup) {
      return;
    }


    popup.classList.remove(
      'is-visible'
    );


    /*
     * Remove page scroll lock
     */

    document.documentElement.classList.remove(
      'luxiaur-gift-popup-open'
    );

    document.body.classList.remove(
      'luxiaur-gift-popup-open'
    );


    /*
     * IMPORTANT:
     *
     * Disable pointer events on the
     * hidden overlay so it cannot sit
     * over the cart drawer/page.
     */

    const overlay =
      popup.querySelector(
        '.luxiaur-gift-overlay'
      );

    if (overlay) {

      overlay.style.pointerEvents =
        'none';

    }


    popupOpen = false;


    console.log(
      'LUXIAUR: Gift popup closed'
    );

  }


  /*
   * --------------------------------------------------
   * ADD GIFT
   * --------------------------------------------------
   */

  async function addGift(color) {

    if (giftProcessing) {
      return;
    }

    giftProcessing = true;


    try {

      const cart =
        await getCart();


      /*
       * Never add more than one
       * complimentary gift.
       */

      if (hasGift(cart)) {
        return;
      }


      const variantId =
        GIFT_VARIANTS[color];


      if (!variantId) {
        throw new Error(
          'Invalid gift color'
        );
      }


      console.log(
        'LUXIAUR: Adding gift:',
        color,
        variantId
      );


      const response =
        await fetch(
          `${Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            credentials: 'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            body: JSON.stringify({

              items: [
                {
                  id: variantId,

                  quantity: 1,

                  properties: {
                    [GIFT_PROPERTY]:
                      'true'
                  }
                }
              ]

            })
          }
        );


      if (!response.ok) {

        throw new Error(
          await response.text()
        );

      }


      console.log(
        'LUXIAUR: Gift added successfully'
      );


      /*
       * Refresh cart data
       */

      const updatedCart =
        await getCart();


      /*
       * Tell Stretch that cart changed
       */

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:change',
          {
            bubbles: true,

            detail: {
              baseEvent:
                'complimentary-gift',

              cart:
                updatedCart
            }
          }
        )
      );


      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );


      /*
       * Some Stretch versions listen
       * on the document instead.
       */

      document.dispatchEvent(
        new CustomEvent(
          'cart:change',
          {
            bubbles: true,

            detail: {
              baseEvent:
                'complimentary-gift',

              cart:
                updatedCart
            }
          }
        )
      );


    } catch (error) {

      console.error(
        'LUXIAUR gift error:',
        error
      );


    } finally {

      giftProcessing = false;

    }

  }


  /*
   * --------------------------------------------------
   * DETECT PRODUCT ADD
   * --------------------------------------------------
   *
   * Stretch opens the cart drawer after
   * adding the product.
   *
   * Instead of depending on Stretch's
   * custom variant:add event, we monitor
   * cart/add.js requests.
   */

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const args =
        arguments;


      const requestUrl =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';


      /*
       * Let Shopify/Stretch perform
       * the original request normally.
       */

      const response =
        await originalFetch.apply(
          this,
          args
        );


      /*
       * Only watch normal Shopify
       * cart additions.
       */

      if (
        requestUrl.includes(
          '/cart/add.js'
        )
      ) {

        setTimeout(
          async function () {

            /*
             * Only show the gift popup
             * on an eligible product page.
             */

            if (
              !isEligiblePage()
            ) {
              return;
            }


            try {

              const cart =
                await getCart();


              const signature =
                getCartSignature(
                  cart
                );


              /*
               * Prevent the same cart
               * addition from triggering
               * repeatedly.
               */

              if (
                signature ===
                lastCartSignature
              ) {
                return;
              }


              lastCartSignature =
                signature;


              /*
               * Gift already exists.
               */

              if (
                hasGift(cart)
              ) {
                return;
              }


              console.log(
                'LUXIAUR: Eligible product added'
              );


              openPopup();


            } catch (error) {

              console.error(
                'LUXIAUR popup detection error:',
                error
              );

            }

          },
          200
        );

      }


      return response;

    };


  /*
   * --------------------------------------------------
   * POPUP STYLES
   * --------------------------------------------------
   */

  const style =
    document.createElement('style');


  style.textContent = `

    /*
     * PAGE LOCK
     */

    html.luxiaur-gift-popup-open,
    body.luxiaur-gift-popup-open {
      overflow: hidden;
    }


    /*
     * POPUP CONTAINER
     */

    #luxiaur-gift-popup {
      position: fixed;
      inset: 0;
      z-index: 9999999;

      /*
       * The container itself must NEVER
       * block the page when the popup
       * is hidden.
       */

      pointer-events: none;
    }


    /*
     * OVERLAY
     */

    .luxiaur-gift-overlay {

      position: fixed;
      inset: 0;

      display: flex;

      align-items: center;
      justify-content: center;

      padding: 20px;

      background:
        rgba(43, 33, 26, .48);


      opacity: 0;
      visibility: hidden;

      /*
       * CRITICAL:
       * Hidden popup cannot intercept
       * clicks.
       */

      pointer-events: none;


      transition:
        opacity .25s ease,
        visibility .25s ease;

    }


    /*
     * VISIBLE POPUP
     */

    #luxiaur-gift-popup.is-visible {
      pointer-events: auto;
    }


    #luxiaur-gift-popup.is-visible
    .luxiaur-gift-overlay {

      opacity: 1;

      visibility: visible;

      pointer-events: auto;

    }


    /*
     * MODAL
     */

    .luxiaur-gift-modal {

      position: relative;

      width:
        min(420px, 100%);

      padding:
        38px 30px 32px;

      background:
        #F5F1EA;

      color:
        #2B211A;

      text-align:
        center;

      border-radius:
        4px;

      box-shadow:
        0 20px 60px
        rgba(0,0,0,.22);

      transform:
        translateY(12px);

      transition:
        transform .25s ease;

    }


    /*
     * MODAL ANIMATION
     */

    #luxiaur-gift-popup.is-visible
    .luxiaur-gift-modal {

      transform:
        translateY(0);

    }


    /*
     * CLOSE BUTTON
     */

    .luxiaur-gift-close {

      position: absolute;

      top: 10px;
      right: 13px;

      width: 32px;
      height: 32px;

      padding: 0;

      border: 0;

      background:
        transparent;

      color:
        #2B211A;

      font-size:
        25px;

      line-height:
        1;

      cursor:
        pointer;

    }


    /*
     * GIFT ICON
     */

    .luxiaur-gift-icon {

      display:
        flex;

      justify-content:
        center;

      margin-bottom:
        15px;

    }


    /*
     * TITLE
     */

    .luxiaur-gift-modal h2 {

      margin:
        0;

      font-size:
        22px;

      font-weight:
        500;

      letter-spacing:
        .01em;

    }


    /*
     * SUBTITLE
     */

    .luxiaur-gift-subtitle {

      margin:
        9px 0 24px;

      color:
        #6f675f;

      font-size:
        14px;

    }


    /*
     * COLOR OPTIONS
     */

    .luxiaur-gift-options {

      display:
        grid;

      grid-template-columns:
        repeat(2, 1fr);

      gap:
        10px;

    }


    /*
     * COLOR BUTTON
     */

    .luxiaur-gift-option {

      display:
        flex;

      align-items:
        center;

      justify-content:
        center;

      gap:
        9px;

      min-height:
        52px;

      padding:
        10px 14px;

      border:
        1px solid #d8d0c5;

      border-radius:
        3px;

      background:
        transparent;

      color:
        #2B211A;

      font-size:
        13px;

      cursor:
        pointer;

      transition:
        border-color .2s ease,
        background .2s ease;

    }


    .luxiaur-gift-option:hover {

      border-color:
        #2B211A;

      background:
        rgba(255,255,255,.35);

    }


    /*
     * COLOR SWATCH
     */

    .luxiaur-gift-swatch {

      display:
        inline-block;

      width:
        18px;

      height:
        18px;

      border-radius:
        50%;

      border:
        1px solid #bdb5aa;

    }


    .luxiaur-swatch-black {

      background:
        #1f1f1f;

    }


    .luxiaur-swatch-white {

      background:
        #ffffff;

    }


    /*
     * NOTE
     */

    .luxiaur-gift-note {

      margin:
        18px 0 0;

      color:
        #81786f;

      font-size:
        11px;

    }


    /*
     * MOBILE
     */

    @media (max-width: 480px) {

      .luxiaur-gift-modal {

        padding:
          34px 20px 26px;

      }


      .luxiaur-gift-options {

        grid-template-columns:
          1fr;

      }

    }

  `;


  document.head.appendChild(style);

})();